<template>
	<div class="industry-chain-v2-page">
		<!-- 全国/重庆切换 - 悬浮右上角 -->
		<div class="region-float">
			<button v-for="opt in regionOptions" :key="opt.code" :class="{ active: regionCode === opt.code }"
				@click="switchRegion(opt.code)">{{ opt.name }}</button>
		</div>

		<!-- 主体：拓扑图 + 企业列表 -->
		<div class="v2-main">
			<section class="v2-panel topology-panel">
				<div class="panel-title topo-title">
					<div>产业链节点拓扑</div>
					<div class="legend">
						<span v-for="item in legendList" :key="item.label" class="legend-item" :class="item.status">
							<i class="dot" :class="item.status"></i>{{ item.label }}
						</span>
					</div>
				</div>
				<div class="panel-body topology-body">
					<div class="topology-flow">
						<div class="topology-stage" v-for="(stage, sIdx) in topologyData" :key="stage.name">
							<div class="stage-head"
								:class="{ active: activeFilter.type === 'stage' && activeFilter.name === stage.label }"
								@click="selectStage(stage)">
								<span class="stage-tag">{{ stage.label }}</span>
							</div>
							<div class="stage-groups">
								<div class="stage-group" v-for="group in stage.groups" :key="group.name">
									<div class="group-name"
										:class="{ active: activeFilter.type === 'group' && activeFilter.name === group.name }"
										@click="selectGroup(group)">{{ group.name }}</div>
									<div class="group-items">
										<div class="topo-item" v-for="item in group.items" :key="item.name"
											:class="[item.status, { active: activeFilter.type === 'node' && activeFilter.name === item.name }]"
											@click="selectTopoNode(item)">
											{{ item.name }}
										</div>
									</div>
								</div>
							</div>
							<div class="stage-arrow" v-if="sIdx < topologyData.length - 1">»</div>
						</div>
					</div>
				</div>
			</section>

			<section class="v2-panel enterprise-panel">
				<div class="panel-title panel-title3">
					<div>核心企业{{ activeFilter.name ? '·' + activeFilter.name : '' }}（{{ matchedEnterpriseTotal
						}}/{{ enterpriseTotal }}家）</div>
				</div>
				<div class="panel-body enterprise-body">
					<div class="enterprise-tabs">
						<button v-for="tab in enterpriseTabs" :key="tab.code" :class="{ active: enterpriseTab === tab.code }"
							@click="switchEnterpriseTab(tab.code)">{{ tab.name }}</button>
					</div>
					<div class="enterprise-table">
						<div class="et-head">
							<span>企业名称</span>
							<span>类型</span>
							<span>注册资本</span>
							<span>法人</span>
							<span>成立日期</span>
							<span>区域</span>
							<span>产业链位置</span>
						</div>
						<div class="et-row" v-for="(row, i) in displayEnterprises" :key="row.code || i">
							<span class="et-name">{{ row.name }}</span>
							<span class="et-type">{{ row.type }}</span>
							<span>{{ formatCapital(row) }}</span>
							<span>{{ row.legal }}</span>
							<span>{{ row.establishDate }}</span>
							<span>{{ row.district }}</span>
							<span class="et-pos">{{ row.position }}</span>
						</div>
					</div>
					<div class="enterprise-pager" v-if="enterpriseLoaded && enterprisePageCount > 1">
						<button :disabled="enterprisePageNo <= 1"
							@click="setEnterprisePage(enterprisePageNo - 1)">上一页</button>
						<span>{{ enterprisePageNo }} / {{ enterprisePageCount }}</span>
						<button :disabled="enterprisePageNo >= enterprisePageCount"
							@click="setEnterprisePage(enterprisePageNo + 1)">下一页</button>
					</div>
				</div>
			</section>
		</div>

		<!-- 底部4个统计图表 -->
		<div class="v2-charts">
			<section class="v2-panel chart-box">
				<div class="panel-title panel-title2">
					<div>企业数量变化趋势(近五年)</div>
				</div>
				<div class="panel-body chart-body">
					<div ref="trendChart" class="chart"></div>
				</div>
			</section>
			<section class="v2-panel chart-box">
				<div class="panel-title panel-title2">
					<div>企业地区分布排行</div>
				</div>
				<div class="panel-body chart-body">
					<div ref="treemapChart" class="chart"></div>
				</div>
			</section>
			<section class="v2-panel chart-box">
				<div class="panel-title panel-title2">
					<div>融资事件</div>
				</div>
				<div class="panel-body chart-body">
					<div ref="financeChart" class="chart"></div>
				</div>
			</section>
			<section class="v2-panel chart-box">
				<div class="panel-title panel-title2">
					<div>产业测评</div>
				</div>
				<div class="panel-body chart-body">
					<div ref="radarChart" class="chart"></div>
					<div class="radar-summary">
						<div class="rs-score"><strong>{{ radarScore }}</strong><span>总分</span></div>
						<div class="rs-level"><span class="rs-pill">{{ radarLevel }}</span><span>{{ radarRank }}</span>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts'

export default {
	name: 'IndustryChainMapV2',
	data() {
		return {
			regionCode: 'chongqing',
			regionOptions: [
				{ code: 'national', name: '全国' },
				{ code: 'chongqing', name: '重庆' }
			],
			chainTag: '火锅产业链',
			legendList: [
				{ status: 'consolidating', label: '持续巩固' },
				{ status: 'insufficient', label: '发展不足' },
				{ status: 'blank', label: '尚处空白' }
			],
			activeFilter: { type: '', code: '', name: '' },
			enterpriseTab: 'all',
			enterpriseTabs: [
				{ code: 'all', name: '全部' },
				{ code: 'leader', name: '龙头企业' },
				{ code: 'listed', name: '上市企业' },
				{ code: 'high-tech', name: '高新技术企业' }
			],
			enterpriseTotal: 1441,
			topologyData: [],
			enterprises: [],
			// 核心企业分页接口数据
			enterpriseList: [],
			enterprisePageTotal: 0,
			enterprisePageNo: 1,
			enterprisePageSize: 10,
			enterpriseLoaded: false,
			radarScore: 69.96,
			radarLevel: '一般',
			radarRank: '全国排名 第一梯队',
			// 接口返回的四组统计数据，为空时图表使用写死数据兜底
			overviewTrend: null,
			overviewDistribution: null,
			overviewFinance: null,
			overviewAssessment: null
		}
	},
	computed: {
		displayEnterprises() {
			if (this.enterpriseLoaded) return this.enterpriseList
			// 接口未返回时用静态兜底数据，按当前筛选在本地过滤
			let list = this.enterprises
			const f = this.activeFilter
			if (f.type === 'stage') list = list.filter(e => e.stage === f.name)
			else if (f.type === 'group') list = list.filter(e => e.group === f.name)
			else if (f.type === 'node') list = list.filter(e => e.node === f.name)
			if (this.enterpriseTab !== 'all') {
				const tab = this.enterpriseTabs.find(t => t.code === this.enterpriseTab)
				if (tab) list = list.filter(e => (e.tags || []).includes(tab.name))
			}
			return list
		},
		// 列表标题分子：接口返回匹配样本数，兜底时取静态列表长度
		matchedEnterpriseTotal() {
			return this.enterpriseLoaded ? this.enterprisePageTotal : this.displayEnterprises.length
		},
		enterprisePageCount() {
			return Math.max(1, Math.ceil(this.enterprisePageTotal / this.enterprisePageSize))
		}
	},
	watch: {
		regionCode() {
			this.refreshChain()
		}
	},
	mounted() {
		this.applyStaticFallback()
		this.$nextTick(() => {
			this.renderAllCharts()
			this.fetchChainOverview()
			this.fetchEnterprisePage()
		})
	},
	beforeDestroy() {
		this.disposeAllCharts()
	},
	methods: {
		statusLabel(status) {
			const map = { consolidating: '持续巩固', insufficient: '发展不足', blank: '尚处空白' }
			return map[status] || ''
		},
		switchRegion(code) {
			if (this.regionCode === code) return
			this.regionCode = code
		},
		// 切换地区时统一刷新：先套用静态兜底立即渲染，再拉取接口覆盖
		refreshChain() {
			this.applyStaticFallback()
			this.renderAllCharts()
			this.fetchChainOverview()
			this.enterprisePageNo = 1
			this.fetchEnterprisePage()
		},
		// 拉取产业链图谱接口
		fetchChainOverview() {
			const code = this.regionCode || 'chongqing'
			this.$request2('/admin-api/statistics/brain/chain/overview?regionCode=' + code).then(res => {
				const value = res.data && res.data.value
				if (!value) return
				this.applyOverview(value)
				this.renderAllCharts()
			}).catch(() => {})
		},
		// 将接口返回的业务数据映射到页面结构
		applyOverview(value) {
			// 图例
			if (Array.isArray(value.legend) && value.legend.length) {
				this.legendList = value.legend
			}
			// 企业分类按钮
			if (Array.isArray(value.enterpriseTypes) && value.enterpriseTypes.length) {
				this.enterpriseTabs = value.enterpriseTypes.map(t => ({ code: t.code, name: t.name }))
			}
			// 企业总量
			if (value.enterpriseTotal != null) {
				this.enterpriseTotal = value.enterpriseTotal
			}
			// 三级拓扑
			if (Array.isArray(value.topology) && value.topology.length) {
				this.topologyData = value.topology
			}
			// 地区选项
			if (Array.isArray(value.regionOptions) && value.regionOptions.length) {
				this.regionOptions = value.regionOptions
			}
			// 四组统计图表数据
			this.overviewTrend = value.enterpriseTrend || null
			this.overviewDistribution = value.regionDistribution || null
			this.overviewFinance = value.financingTrend || null
			this.overviewAssessment = value.assessment || null
			if (value.assessment) {
				if (value.assessment.score != null) this.radarScore = value.assessment.score
				if (value.assessment.level) this.radarLevel = value.assessment.level
				if (value.assessment.rank) this.radarRank = value.assessment.rank
			}
			// 切换地区后重置筛选
			this.activeFilter = { type: '', code: '', name: '' }
			this.enterpriseTab = 'all'
		},
		// 切换企业分类标签（按 tags 服务端筛选）
		switchEnterpriseTab(code) {
			if (this.enterpriseTab === code) return
			this.enterpriseTab = code
			this.refreshEnterprises(true)
		},
		// 切换企业分页
		setEnterprisePage(pageNo) {
			if (pageNo < 1 || pageNo > this.enterprisePageCount || pageNo === this.enterprisePageNo) return
			this.enterprisePageNo = pageNo
			this.fetchEnterprisePage()
		},
		// 筛选变化统一刷新企业列表，resetPage 时回到第一页
		refreshEnterprises(resetPage) {
			if (resetPage) this.enterprisePageNo = 1
			this.fetchEnterprisePage()
		},
		// 拉取核心企业筛选分页接口
		fetchEnterprisePage() {
			const params = ['regionCode=' + (this.regionCode || 'chongqing')]
			if (this.enterpriseTab && this.enterpriseTab !== 'all') params.push('enterpriseType=' + this.enterpriseTab)
			// filterType 与 filterCode 必须成对传入
			if (this.activeFilter.type && this.activeFilter.code) {
				params.push('filterType=' + this.activeFilter.type)
				params.push('filterCode=' + this.activeFilter.code)
			}
			params.push('pageNo=' + this.enterprisePageNo)
			params.push('pageSize=' + this.enterprisePageSize)
			this.$request2('/admin-api/statistics/brain/chain/enterprise/page?' + params.join('&')).then(res => {
				const value = res.data && res.data.value
				if (!value) return
				const page = value.page || {}
				this.enterpriseLoaded = true
				this.enterpriseList = (page.list || []).map(this.mapEnterprise)
				this.enterprisePageTotal = page.total || 0
				if (value.enterpriseTotal != null) this.enterpriseTotal = value.enterpriseTotal
			}).catch(() => {})
		},
		mapEnterprise(e) {
			return {
				code: e.code,
				name: e.name,
				type: e.type,
				tags: e.tags || [],
				capital: e.capital,
				capitalUnit: e.capitalUnit || '',
				legal: e.legal,
				establishDate: e.establishDate,
				district: e.district,
				position: e.position,
				stageCode: e.stageCode,
				groupCode: e.groupCode,
				nodeCode: e.nodeCode
			}
		},
		formatCapital(row) {
			if (!row) return ''
			if (row.capitalUnit) {
				const num = typeof row.capital === 'number' ? row.capital.toLocaleString('en-US') : row.capital
				return num + row.capitalUnit
			}
			return row.capital
		},
		selectStage(stage) {
			if (this.activeFilter.type === 'stage' && this.activeFilter.code === stage.code) {
				this.activeFilter = { type: '', code: '', name: '' }
			} else {
				this.activeFilter = { type: 'stage', code: stage.code, name: stage.label }
			}
			this.enterpriseTab = 'all'
			this.refreshEnterprises(true)
		},
		selectGroup(group) {
			if (this.activeFilter.type === 'group' && this.activeFilter.code === group.code) {
				this.activeFilter = { type: '', code: '', name: '' }
			} else {
				this.activeFilter = { type: 'group', code: group.code, name: group.name }
			}
			this.enterpriseTab = 'all'
			this.refreshEnterprises(true)
		},
		selectTopoNode(node) {
			if (this.activeFilter.type === 'node' && this.activeFilter.code === node.code) {
				this.activeFilter = { type: '', code: '', name: '' }
			} else {
				this.activeFilter = { type: 'node', code: node.code, name: node.name }
			}
			this.enterpriseTab = 'all'
			this.refreshEnterprises(true)
		},
		// 静态兜底数据：接口失败/缺配置时保证页面不空白
		applyStaticFallback() {
			this.legendList = [
				{ status: 'consolidating', label: '持续巩固' },
				{ status: 'insufficient', label: '发展不足' },
				{ status: 'blank', label: '尚处空白' }
			]
			this.overviewTrend = null
			this.overviewDistribution = null
			this.overviewFinance = null
			this.overviewAssessment = null
			this.enterpriseLoaded = false
			this.enterpriseList = []
			this.enterprisePageTotal = 0
			this.enterprisePageNo = 1
			if (this.regionCode === 'chongqing') {
				this.chainTag = '火锅产业链'
				this.enterpriseTotal = 1441
				this.topologyData = [
					{
						label: '上游', name: '种养原料基地',
						groups: [
							{
								name: '种养原料基地',
								items: [
									{ name: '蔬菜种植', status: 'consolidating', desc: '辣椒、生菜等叶菜类基地稳定供应，主产区集中渝北、巴南。', metrics: [{ label: '基地数', value: '128个' }, { label: '年产', value: '36万吨' }, { label: '缺口', value: '8%' }] },
									{ name: '香辛料种植', status: 'insufficient', desc: '花椒、八角等香辛料部分依赖外调，江津花椒本地化率约60%。', metrics: [{ label: '基地数', value: '46个' }, { label: '年产', value: '4.2万吨' }, { label: '缺口', value: '40%' }] },
									{ name: '牲畜家禽饲养', status: 'insufficient', desc: '牛肉、毛肚等肉类供应不足，毛肚高度依赖外地调入。', metrics: [{ label: '养殖场', value: '312家' }, { label: '年产', value: '12万吨' }, { label: '缺口', value: '52%' }] },
									{ name: '水产养殖捕捞', status: 'blank', desc: '鱼片、虾滑等水产原料本地养殖规模有限，主要靠冷链引入。', metrics: [{ label: '养殖场', value: '18家' }, { label: '年产', value: '1.2万吨' }, { label: '缺口', value: '78%' }] }
								]
							}
						]
					},
					{
						label: '中游', name: '生产加工',
						groups: [
							{
								name: '底料工厂',
								items: [
									{ name: '牛油麻辣', status: 'consolidating', desc: '牛油麻辣底料产能位居全国前列，渝北、巴南为集群。', metrics: [{ label: '工厂数', value: '18家' }, { label: '日产', value: '96吨' }, { label: '外销', value: '18吨/日' }] },
									{ name: '清油底料', status: 'consolidating', desc: '清油底料健康化品类增长稳定，主供本地连锁品牌。', metrics: [{ label: '工厂数', value: '12家' }, { label: '日产', value: '48吨' }, { label: '外销', value: '8吨/日' }] },
									{ name: '番茄底料', status: 'consolidating', desc: '番茄底料旺季偏紧，渝东北需跨区调度。', metrics: [{ label: '工厂数', value: '7家' }, { label: '日产', value: '38吨' }, { label: '缺口', value: '18%' }] },
									{ name: '酸汤底料', status: 'insufficient', desc: '酸汤底料处于扩张期，渝东南小幅缺口。', metrics: [{ label: '工厂数', value: '5家' }, { label: '日产', value: '24吨' }, { label: '缺口', value: '9%' }] }
								]
							},
							{
								name: '生鲜食材加工',
								items: [
									{ name: '毛肚加工', status: 'consolidating', desc: '鲜毛肚、冷冻毛肚加工链完备，冷链半径覆盖良好。', metrics: [{ label: '工厂数', value: '14家' }, { label: '日产', value: '62吨' }, { label: '外销', value: '12吨/日' }] },
									{ name: '牛肉加工', status: 'consolidating', desc: '鲜切牛肉、雪花牛肉加工供应整体平稳。', metrics: [{ label: '工厂数', value: '12家' }, { label: '日产', value: '48吨' }, { label: '外销', value: '9吨/日' }] },
									{ name: '丸滑加工', status: 'insufficient', desc: '虾滑、牛肉丸旺季缺口较大，需跨区调运。', metrics: [{ label: '工厂数', value: '10家' }, { label: '日产', value: '36吨' }, { label: '缺口', value: '14%' }] }
								]
							},
							{
								name: '预制菜加工',
								items: [
									{ name: '自热火锅', status: 'insufficient', desc: '自热火锅旺季产能紧张，淡季略过剩。', metrics: [{ label: '工厂数', value: '15家' }, { label: '日产', value: '12万盒' }, { label: '缺口', value: '8%' }] },
									{ name: '火锅食材包', status: 'consolidating', desc: '火锅食材包供需平稳，覆盖2/4人餐与家庭装。', metrics: [{ label: '工厂数', value: '10家' }, { label: '日产', value: '4万套' }, { label: '缺口', value: '3%' }] }
								]
							},
							{
								name: '包装与厨具',
								items: [
									{ name: '底料包装', status: 'consolidating', desc: '底料铝箔袋、自立袋供应稳定。', metrics: [{ label: '工厂数', value: '9家' }, { label: '日产', value: '20万袋' }, { label: '外销', value: '6万袋/日' }] },
									{ name: '预制菜包装', status: 'consolidating', desc: '预制菜包装配套完整，环保材料占比上升。', metrics: [{ label: '工厂数', value: '9家' }, { label: '日产', value: '15万盒' }, { label: '外销', value: '5万盒/日' }] },
									{ name: '火锅灶具', status: 'insufficient', desc: '火锅灶具本地配套为主，旺季需提前备货。', metrics: [{ label: '工厂数', value: '8家' }, { label: '月产', value: '1800台' }, { label: '缺口', value: '9%' }] },
									{ name: '制冷设备', status: 'consolidating', desc: '冷藏柜、冷冻柜供应稳定。', metrics: [{ label: '工厂数', value: '7家' }, { label: '月产', value: '900台' }, { label: '缺口', value: '4%' }] }
								]
							}
						]
					},
					{
						label: '下游', name: '门店与消费',
						groups: [
							{
								name: '连锁火锅品牌',
								items: [
									{ name: '直营门店', status: 'consolidating', desc: '重庆本地直营连锁品牌密度全国第一。', metrics: [{ label: '品牌数', value: '86个' }, { label: '门店数', value: '682家' }, { label: '饱和度', value: '高' }] },
									{ name: '加盟门店', status: 'consolidating', desc: '加盟门店持续扩张，覆盖主要城市商圈。', metrics: [{ label: '品牌数', value: '64个' }, { label: '门店数', value: '428家' }, { label: '饱和度', value: '中高' }] },
									{ name: '海外门店', status: 'insufficient', desc: '海外门店持续扩张，主要覆盖东南亚、北美。', metrics: [{ label: '品牌数', value: '36个' }, { label: '门店数', value: '176家' }, { label: '国家', value: '18国' }] }
								]
							},
							{
								name: '社区火锅门店',
								items: [
									{ name: '主城社区店', status: 'consolidating', desc: '主城社区小店密集分布，饱和度高。', metrics: [{ label: '门店数', value: '762家' }, { label: '覆盖街道', value: '186个' }, { label: '饱和度', value: '高' }] },
									{ name: '区县社区店', status: 'insufficient', desc: '区县社区店分布不均，部分区县供给不足。', metrics: [{ label: '门店数', value: '420家' }, { label: '覆盖区县', value: '38个' }, { label: '缺口', value: '22%' }] }
								]
							},
							{
								name: '火锅文旅街区',
								items: [
									{ name: '文旅主题街区', status: 'insufficient', desc: '文旅火锅主题街区处于培育期，体验型业态供给不足。', metrics: [{ label: '街区数', value: '6个' }, { label: '门店数', value: '64家' }, { label: '缺口', value: '36%' }] },
									{ name: '体验型门店', status: 'blank', desc: '沉浸式体验门店尚处空白，培育中。', metrics: [{ label: '门店数', value: '12家' }, { label: '缺口', value: '68%' }, { label: '建议', value: '重点培育' }] }
								]
							},
							{
								name: '预制菜零售',
								items: [
									{ name: '电商渠道', status: 'blank', desc: 'C端电商渠道尚未规模化布局。', metrics: [{ label: '网点数', value: '220个' }, { label: '月销', value: '6万盒' }, { label: '缺口', value: '62%' }] },
									{ name: '商超渠道', status: 'blank', desc: '商超渠道铺设率低，重点空白。', metrics: [{ label: '网点数', value: '100个' }, { label: '月销', value: '2万盒' }, { label: '缺口', value: '74%' }] }
								]
							}
						]
					}
				]
				this.enterprises = [
					{ name: '重庆桥头火锅餐饮管理有限公司', type: '龙头企业', tags: ['龙头企业', '上市企业'], capital: '52,800万', legal: '朱明', establishDate: '1998-06-12', district: '渝中区', position: '连锁火锅品牌·直营', node: '直营门店', stage: '下游', group: '连锁火锅品牌' },
					{ name: '重庆周师兄火锅食品有限公司', type: '龙头企业', tags: ['龙头企业'], capital: '36,000万', legal: '周鹏', establishDate: '2014-09-22', district: '江北区', position: '连锁火锅品牌·加盟', node: '加盟门店', stage: '下游', group: '连锁火锅品牌' },
					{ name: '重庆德庄实业(集团)有限公司', type: '上市企业', tags: ['上市企业', '高新技术企业'], capital: '120,000万', legal: '李德建', establishDate: '1999-08-18', district: '渝北区', position: '底料工厂·牛油麻辣', node: '牛油麻辣', stage: '中游', group: '底料工厂' },
					{ name: '重庆秋霞食品有限公司', type: '高新技术企业', tags: ['高新技术企业'], capital: '8,600万', legal: '汪秋', establishDate: '2003-04-15', district: '巴南区', position: '底料工厂·清油', node: '清油底料', stage: '中游', group: '底料工厂' },
					{ name: '重庆毛哥食品开发有限公司', type: '高新技术企业', tags: ['高新技术企业', '龙头企业'], capital: '15,200万', legal: '毛亮', establishDate: '2008-11-08', district: '渝北区', position: '生鲜食材加工·毛肚', node: '毛肚加工', stage: '中游', group: '生鲜食材加工' },
					{ name: '重庆琼记商贸有限公司', type: '专精特新', tags: ['专精特新'], capital: '3,200万', legal: '陈琼', establishDate: '2016-03-30', district: '九龙坡区', position: '预制菜加工·自热火锅', node: '自热火锅', stage: '中游', group: '预制菜加工' }
				]
				this.radarScore = 69.96
				this.radarLevel = '一般'
				this.radarRank = '全国排名 第一梯队'
			} else {
				this.chainTag = '火锅产业链'
				this.enterpriseTotal = 12860
				this.topologyData = [
					{
						label: '上游', name: '种养原料基地',
						groups: [
							{
								name: '种养原料基地',
								items: [
									{ name: '蔬菜种植', status: 'consolidating', desc: '全国叶菜种植充足，川渝、云贵为辣椒主产区。', metrics: [{ label: '基地数', value: '1860个' }, { label: '年产', value: '420万吨' }, { label: '缺口', value: '4%' }] },
									{ name: '香辛料种植', status: 'consolidating', desc: '花椒、八角、桂皮等香辛料供给平衡。', metrics: [{ label: '基地数', value: '520个' }, { label: '年产', value: '46万吨' }, { label: '缺口', value: '12%' }] },
									{ name: '牲畜家禽饲养', status: 'insufficient', desc: '牛羊肉供给偏紧，国内产能集中北方牧区。', metrics: [{ label: '养殖场', value: '4200家' }, { label: '年产', value: '180万吨' }, { label: '缺口', value: '28%' }] },
									{ name: '水产养殖捕捞', status: 'consolidating', desc: '鱼片、虾滑原料以沿海养殖为主。', metrics: [{ label: '养殖场', value: '2800家' }, { label: '年产', value: '95万吨' }, { label: '缺口', value: '8%' }] }
								]
							}
						]
					},
					{
						label: '中游', name: '生产加工',
						groups: [
							{
								name: '底料工厂',
								items: [
									{ name: '牛油麻辣', status: 'consolidating', desc: '全国底料工厂分布广泛，川渝产能领先。', metrics: [{ label: '工厂数', value: '220家' }, { label: '日产', value: '1180吨' }, { label: '外销', value: '220吨/日' }] },
									{ name: '清油底料', status: 'consolidating', desc: '清油底料健康化品类增长稳定。', metrics: [{ label: '工厂数', value: '120家' }, { label: '日产', value: '620吨' }, { label: '外销', value: '120吨/日' }] },
									{ name: '番茄底料', status: 'consolidating', desc: '番茄底料供应平衡。', metrics: [{ label: '工厂数', value: '80家' }, { label: '日产', value: '420吨' }, { label: '外销', value: '80吨/日' }] },
									{ name: '酸汤底料', status: 'insufficient', desc: '酸汤底料区域分布不均，旺季偏紧。', metrics: [{ label: '工厂数', value: '60家' }, { label: '日产', value: '380吨' }, { label: '缺口', value: '15%' }] }
								]
							},
							{
								name: '生鲜食材加工',
								items: [
									{ name: '毛肚加工', status: 'consolidating', desc: '毛肚、牛肉加工链完备。', metrics: [{ label: '工厂数', value: '180家' }, { label: '日产', value: '920吨' }, { label: '外销', value: '180吨/日' }] },
									{ name: '牛肉加工', status: 'consolidating', desc: '鲜切牛肉供应整体平稳。', metrics: [{ label: '工厂数', value: '120家' }, { label: '日产', value: '560吨' }, { label: '外销', value: '90吨/日' }] },
									{ name: '丸滑加工', status: 'insufficient', desc: '虾滑、牛肉丸旺季缺口较大。', metrics: [{ label: '工厂数', value: '60家' }, { label: '日产', value: '340吨' }, { label: '缺口', value: '15%' }] }
								]
							},
							{
								name: '预制菜加工',
								items: [
									{ name: '自热火锅', status: 'insufficient', desc: '自热火锅产能持续扩张，旺季仍偏紧。', metrics: [{ label: '工厂数', value: '120家' }, { label: '日产', value: '120万盒' }, { label: '缺口', value: '15%' }] },
									{ name: '火锅食材包', status: 'consolidating', desc: '火锅食材包供应平稳。', metrics: [{ label: '工厂数', value: '90家' }, { label: '日产', value: '60万套' }, { label: '缺口', value: '6%' }] }
								]
							},
							{
								name: '包装与厨具',
								items: [
									{ name: '底料包装', status: 'consolidating', desc: '包装配套成熟，环保材料占比上升。', metrics: [{ label: '工厂数', value: '120家' }, { label: '日产', value: '220万袋' }, { label: '外销', value: '40万袋/日' }] },
									{ name: '预制菜包装', status: 'consolidating', desc: '预制菜包装配套完整。', metrics: [{ label: '工厂数', value: '100家' }, { label: '日产', value: '200万盒' }, { label: '外销', value: '40万盒/日' }] },
									{ name: '火锅灶具', status: 'consolidating', desc: '灶具供给平衡，高端件依赖进口。', metrics: [{ label: '工厂数', value: '100家' }, { label: '月产', value: '1.8万台' }, { label: '缺口', value: '12%' }] },
									{ name: '制冷设备', status: 'consolidating', desc: '冷藏柜、冷冻柜供应稳定。', metrics: [{ label: '工厂数', value: '80家' }, { label: '月产', value: '1.4万台' }, { label: '缺口', value: '6%' }] }
								]
							}
						]
					},
					{
						label: '下游', name: '门店与消费',
						groups: [
							{
								name: '连锁火锅品牌',
								items: [
									{ name: '直营门店', status: 'consolidating', desc: '连锁品牌全国布局加速，下沉市场占比提升。', metrics: [{ label: '品牌数', value: '680个' }, { label: '门店数', value: '7.2万家' }, { label: '饱和度', value: '中高' }] },
									{ name: '加盟门店', status: 'consolidating', desc: '加盟门店扩张加速，区域覆盖持续提升。', metrics: [{ label: '品牌数', value: '600个' }, { label: '门店数', value: '5.4万家' }, { label: '饱和度', value: '中' }] },
									{ name: '海外门店', status: 'insufficient', desc: '海外门店持续扩张，主要覆盖东南亚、欧美。', metrics: [{ label: '品牌数', value: '180个' }, { label: '门店数', value: '1.6万家' }, { label: '国家', value: '32国' }] }
								]
							},
							{
								name: '社区火锅门店',
								items: [
									{ name: '主城社区店', status: 'consolidating', desc: '社区门店饱和度高，区域竞争激烈。', metrics: [{ label: '门店数', value: '5.8万家' }, { label: '覆盖城市', value: '320个' }, { label: '饱和度', value: '高' }] },
									{ name: '区县社区店', status: 'insufficient', desc: '区县社区店分布不均，部分区县供给不足。', metrics: [{ label: '门店数', value: '3.8万家' }, { label: '覆盖区县', value: '1280个' }, { label: '缺口', value: '20%' }] }
								]
							},
							{
								name: '火锅文旅街区',
								items: [
									{ name: '文旅主题街区', status: 'insufficient', desc: '文旅火锅主题街区培育中，区域分布不均。', metrics: [{ label: '街区数', value: '46个' }, { label: '门店数', value: '520家' }, { label: '缺口', value: '30%' }] },
									{ name: '体验型门店', status: 'insufficient', desc: '沉浸式体验门店处于培育期。', metrics: [{ label: '门店数', value: '180家' }, { label: '缺口', value: '36%' }, { label: '建议', value: '重点培育' }] }
								]
							},
							{
								name: '预制菜零售',
								items: [
									{ name: '电商渠道', status: 'insufficient', desc: 'C端电商渠道快速扩张，但供给端分散。', metrics: [{ label: '网点数', value: '1.8万个' }, { label: '月销', value: '320万盒' }, { label: '缺口', value: '22%' }] },
									{ name: '商超渠道', status: 'insufficient', desc: '商超渠道铺设率上升，区域分化。', metrics: [{ label: '网点数', value: '8200个' }, { label: '月销', value: '100万盒' }, { label: '缺口', value: '28%' }] }
								]
							}
						]
					}
				]
				this.enterprises = [
					{ name: '四川海底捞餐饮股份有限公司', type: '龙头企业', tags: ['龙头企业', '上市企业'], capital: '580,000万', legal: '张勇', establishDate: '2001-05-18', district: '成都市', position: '连锁火锅品牌·直营', node: '直营门店', stage: '下游', group: '连锁火锅品牌' },
					{ name: '内蒙古西贝餐饮集团有限公司', type: '上市企业', tags: ['上市企业'], capital: '320,000万', legal: '贾国龙', establishDate: '1997-07-08', district: '北京市', position: '连锁火锅品牌·加盟', node: '加盟门店', stage: '下游', group: '连锁火锅品牌' },
					{ name: '郑州巴奴毛肚火锅有限公司', type: '龙头企业', tags: ['龙头企业'], capital: '120,000万', legal: '杜中兵', establishDate: '2001-04-18', district: '郑州市', position: '连锁火锅品牌·直营', node: '直营门店', stage: '下游', group: '连锁火锅品牌' },
					{ name: '四川小龙坎餐饮管理有限公司', type: '上市企业', tags: ['上市企业', '高新技术企业'], capital: '86,000万', legal: '朱吉', establishDate: '2014-08-08', district: '成都市', position: '底料工厂·牛油麻辣', node: '牛油麻辣', stage: '中游', group: '底料工厂' },
					{ name: '浙江锅圈食汇食品有限公司', type: '高新技术企业', tags: ['高新技术企业'], capital: '48,000万', legal: '杨明', establishDate: '2017-06-20', district: '杭州市', position: '预制菜加工·自热火锅', node: '自热火锅', stage: '中游', group: '预制菜加工' },
					{ name: '广东美的厨电有限公司', type: '高新技术企业', tags: ['高新技术企业', '专精特新'], capital: '210,000万', legal: '方洪波', establishDate: '2002-03-12', district: '佛山市', position: '厨具设备·火锅灶具', node: '火锅灶具', stage: '中游', group: '包装与厨具' }
				]
				this.radarScore = 76.42
				this.radarLevel = '良好'
				this.radarRank = '全国排名 第一梯队'
			}
			this.activeFilter = { type: '', code: '', name: '' }
			this.enterpriseTab = 'all'
		},
		renderAllCharts() {
			this.renderTrendChart()
			this.renderTreemapChart()
			this.renderFinanceChart()
			this.renderRadarChart()
		},
		getChart(element) {
			return element ? (echarts.getInstanceByDom(element) || echarts.init(element)) : null
		},
		chartOption(chart, option) {
			if (chart) {
				chart.clear()
				chart.setOption(option)
				window.setTimeout(() => chart.resize(), 0)
			}
		},
		disposeAllCharts() {
			['trendChart', 'treemapChart', 'financeChart', 'radarChart'].forEach(refName => {
				const el = this.$refs[refName]
				const chart = el && echarts.getInstanceByDom(el)
				if (chart) chart.dispose()
			})
		},
		renderTrendChart() {
			const chart = this.getChart(this.$refs.trendChart)
			if (!chart) return
			const t = (this.overviewTrend && Array.isArray(this.overviewTrend.values) && this.overviewTrend.values.length)
				? this.overviewTrend : null
			const data = t
				? { years: (t.years || []).map(String), values: t.values }
				: (this.regionCode === 'chongqing'
					? { years: ['2021', '2022', '2023', '2024', '2025'], values: [1180, 1268, 1342, 1396, 1441] }
					: { years: ['2021', '2022', '2023', '2024', '2025'], values: [9860, 10620, 11480, 12160, 12860] })
			const unit = (t && t.unit) || '家'
			this.chartOption(chart, {
				tooltip: { trigger: 'axis', formatter: '{b}<br/>企业数量: {c}' + unit },
				grid: { left: 50, right: 18, top: 24, bottom: 28 },
				xAxis: { type: 'category', data: data.years, axisLine: { lineStyle: { color: '#367aa5' } }, axisLabel: { color: '#b3c8d4', fontSize: 11 } },
				yAxis: { type: 'value', axisLine: { show: false }, axisLabel: { color: '#b3c8d4', fontSize: 10 }, splitLine: { lineStyle: { color: 'rgba(68, 193, 239, .15)' } } },
				series: [{
					type: 'line',
					data: data.values,
					smooth: true,
					symbolSize: 7,
					itemStyle: { color: '#44c1ef' },
					lineStyle: { width: 2, color: '#44c1ef' },
					areaStyle: { color: 'rgba(68, 193, 239, .15)' },
					emphasis: { itemStyle: { borderColor: '#fff', borderWidth: 2, shadowBlur: 10, shadowColor: '#44c1ef' } }
				}]
			})
		},
		renderTreemapChart() {
			const chart = this.getChart(this.$refs.treemapChart)
			if (!chart) return
			const dist = (this.overviewDistribution && Array.isArray(this.overviewDistribution.items) && this.overviewDistribution.items.length)
				? this.overviewDistribution : null
			const data = dist
				? dist.items
				: (this.regionCode === 'chongqing'
					? [{ name: '渝北区', value: 181 }, { name: '九龙坡区', value: 171 }, { name: '江北区', value: 147 }, { name: '璧山区', value: 117 }, { name: '渝中区', value: 111 }, { name: '南岸区', value: 96 }, { name: '巴南区', value: 92 }, { name: '其他', value: 426 }]
					: [{ name: '成都市', value: 1620 }, { name: '重庆市', value: 1441 }, { name: '北京市', value: 1180 }, { name: '郑州市', value: 920 }, { name: '上海市', value: 860 }, { name: '广州市', value: 720 }, { name: '西安市', value: 580 }, { name: '其他', value: 5539 }])
			const unit = (dist && dist.unit) || '家'
			this.chartOption(chart, {
				tooltip: { formatter: '{b}: {c}' + unit },
				series: [{
					type: 'treemap',
					roam: false,
					nodeClick: false,
					breadcrumb: { show: false },
					label: { color: '#fff', fontSize: 11, formatter: '{b}\n{c}' },
					itemStyle: { borderColor: '#0a1628', borderWidth: 2, gapWidth: 2 },
					levels: [{ itemStyle: { borderColor: '#0a1628', borderWidth: 2, gapWidth: 2 } }],
					data: data.map((d, i) => ({
						name: d.name,
						value: d.value,
						itemStyle: { color: ['#168cff', '#36c6dc', '#44c1ef', '#9bc74b', '#e1b46d', '#f0996e', '#8ad4ff', '#5a78a8'][i % 8] }
					}))
				}]
			})
		},
		renderFinanceChart() {
			const chart = this.getChart(this.$refs.financeChart)
			if (!chart) return
			const f = (this.overviewFinance && Array.isArray(this.overviewFinance.values) && this.overviewFinance.values.length)
				? this.overviewFinance : null
			const data = f
				? { years: (f.years || []).map(String), values: f.values }
				: (this.regionCode === 'chongqing'
					? { years: ['2021', '2022', '2023', '2024', '2025'], values: [5, 3, 12, 4, 1] }
					: { years: ['2021', '2022', '2023', '2024', '2025'], values: [48, 36, 92, 42, 18] })
			const unit = (f && f.unit) || '起'
			this.chartOption(chart, {
				tooltip: { trigger: 'axis', formatter: '{b}<br/>融资事件: {c}' + unit },
				grid: { left: 42, right: 18, top: 24, bottom: 28 },
				xAxis: { type: 'category', data: data.years, axisLine: { lineStyle: { color: '#367aa5' } }, axisLabel: { color: '#b3c8d4', fontSize: 11 } },
				yAxis: { type: 'value', axisLine: { show: false }, axisLabel: { color: '#b3c8d4', fontSize: 10 }, splitLine: { lineStyle: { color: 'rgba(68, 193, 239, .15)' } } },
				series: [{
					type: 'bar',
					data: data.values,
					barWidth: '48%',
					itemStyle: {
						borderRadius: [4, 4, 0, 0],
						color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#44c1ef' }, { offset: 1, color: 'rgba(68, 193, 239, .25)' }] }
					},
					emphasis: { itemStyle: { color: '#5fd4ff' } }
				}]
			})
		},
		renderRadarChart() {
			const chart = this.getChart(this.$refs.radarChart)
			if (!chart) return
			const a = (this.overviewAssessment && Array.isArray(this.overviewAssessment.indicators) && this.overviewAssessment.indicators.length)
				? this.overviewAssessment : null
			const indicators = a
				? a.indicators.map(i => ({ name: i.name, max: i.max }))
				: [
					{ name: '企业数量', max: 100 },
					{ name: '产业链完整度', max: 100 },
					{ name: '龙头企业', max: 100 },
					{ name: '高价值环节', max: 100 },
					{ name: '高效企业', max: 100 },
					{ name: '优势环节', max: 100 },
					{ name: '产业专利', max: 100 }
				]
			const values = a
				? a.indicators.map(i => i.value)
				: (this.regionCode === 'chongqing' ? [62, 68, 75, 58, 72, 64, 70] : [78, 82, 86, 74, 80, 76, 79])
			const seriesName = this.regionCode === 'chongqing' ? '重庆' : '全国'
			this.chartOption(chart, {
				tooltip: { trigger: 'item', appendToBody: true, confine: false },
				radar: {
					indicator: indicators,
					axisName: { color: '#b3c8d4', fontSize: 10 },
					splitLine: { lineStyle: { color: 'rgba(68, 193, 239, .25)' } },
					splitArea: { areaStyle: { color: ['rgba(10, 63, 113, .12)', 'rgba(10, 63, 113, .24)'] } },
					axisLine: { lineStyle: { color: 'rgba(68, 193, 239, .3)' } }
				},
				series: [{
					type: 'radar',
					data: [{
						value: values,
						name: seriesName,
						itemStyle: { color: '#44c1ef' },
						areaStyle: { color: 'rgba(68, 193, 239, .2)' },
						lineStyle: { color: '#44c1ef', width: 2 }
					}]
				}]
			})
		}
	}
}
</script>

<style scoped lang="scss">
.industry-chain-v2-page {
	position: absolute;
	top: 75px;
	right: 0;
	bottom: 0;
	left: 0;
	display: grid;
	grid-template-rows: minmax(0, 1.2fr) minmax(0, 1fr);
	row-gap: 12px;
	box-sizing: border-box;
	padding: 10px 38px 22px;
	overflow: hidden;
	color: #d8f1ff;
	font-family: 'Microsoft YaHei', sans-serif;
}

/* 全国/重庆切换 - 悬浮右上角 */
.region-float {
	position: fixed;
	top: 64px;
	right: 38px;
	z-index: 99;
	display: flex;
	gap: 6px;
	padding: 6px;
	background: rgba(10, 32, 78, .55);
	border: 1px solid rgba(68, 193, 239, .4);
	border-radius: 4px;
	box-shadow: 0 0 14px rgba(0, 14, 40, .55);
	backdrop-filter: blur(6px);
}

.region-float button {
	min-width: 64px;
	height: 30px;
	border: 1px solid rgba(68, 193, 239, .55);
	background: rgba(10, 63, 113, .25);
	color: #b8d2e8;
	font-size: 13px;
	cursor: pointer;
	transition: .2s;
}

.region-float button.active {
	background: linear-gradient(90deg, #168cff, #36c6dc);
	color: #fff;
	border-color: transparent;
	box-shadow: 0 0 10px rgba(24, 140, 255, .55);
}

/* 拓扑标题栏 + 图例 */
.topo-title {
	display: flex;
	align-items: center;
	gap: 18px;
	padding-right: 18px;
}

.topo-title>div:first-child {
	flex: 0 0 auto;
}

.legend {
	display: flex;
	gap: 16px;
	margin-left: auto;
	font-size: 12px;
	padding-right: 18px;
}

.legend-item {
	display: flex;
	align-items: center;
	gap: 6px;
	font-weight: 600;
	font-size: 15px;
}

.legend-item .dot {
	width: 22px;
	height: 10px;
	border-radius: 2px;
}

.legend-item.consolidating { color: #4cd964 !important;  }
	.legend-item.insufficient { color: #44c1ef; }
	.legend-item.blank { color: #ff7a45; }

.dot.consolidating {
	background: linear-gradient(90deg, #4cd964, #38b850);
	box-shadow: 0 0 8px rgba(76, 217, 100, .65);
}

.dot.insufficient {
	background: linear-gradient(90deg, #44c1ef, #36c6dc);
	box-shadow: 0 0 8px rgba(68, 193, 239, .65);
}

.dot.blank {
	background: linear-gradient(90deg, #ff7a45, #e85d3a);
	box-shadow: 0 0 8px rgba(255, 122, 69, .65);
}

/* 主体 */
.v2-main {
	display: grid;
	grid-template-columns: 1.4fr 1fr;
	gap: 14px;
	min-height: 0;
}

.v2-panel {
	position: relative;
	display: flex;
	flex-direction: column;
	min-width: 0;
	min-height: 0;
}

.panel-title {
	flex: 0 0 auto;
	width: 100%;
	height: 38px;
	background: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A0%87%E9%A2%98%402x.png') left / 45% 100% no-repeat;
}

.panel-title2 {
	background: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A0%87%E9%A2%98%402x.png') left / 100% 100% no-repeat !important;
}

.panel-title3 {
	background: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A0%87%E9%A2%98%402x.png') left / 60% 100% no-repeat !important;
}

.panel-title > div:first-child {
	padding-left: 48px;
	font-family: JiangChengXieHei, JiangChengXieHei;
	font-size: 20px;
	font-weight: 900;
	font-style: italic;
	line-height: 30px;
	background: linear-gradient(180deg, #fff 15%, #f7ff57 81%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

.panel-body {
	position: relative;
	flex: 1 1 auto;
	min-height: 0;
	box-sizing: border-box;
	padding: 16px 18px;
	border: 1px solid rgba(68, 193, 239, .42);
	border-radius: 4px;
	background:
		linear-gradient(135deg, rgba(68, 193, 239, .14), transparent 22%) top left,
		linear-gradient(315deg, rgba(68, 193, 239, .1), transparent 22%) bottom right,
		rgba(10, 63, 113, .34);
	box-shadow: inset 0 0 24px rgba(24, 132, 255, .12), 0 0 10px rgba(0, 14, 40, .22);
	overflow: auto;
}

.panel-body::-webkit-scrollbar {
	width: 6px;
	height: 6px;
}

.panel-body::-webkit-scrollbar-track {
	background: rgba(202, 199, 199, .08);
	border-radius: 4px;
}

.panel-body::-webkit-scrollbar-thumb {
	background: rgba(68, 193, 239, .55);
	border-radius: 4px;
}

/* 拓扑图 */
.topology-flow {
	display: flex;
	gap: 14px;
	min-height: 0;
}

.topology-stage {
	flex: 1;
	min-width: 0;
	position: relative;
	display: flex;
	flex-direction: column;
}

.stage-head {
	width: 70%;
	margin: 0 auto 12px;
	padding: 7px 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(90deg, #168cff, #36c6dc);
	border: 1px solid rgba(120, 220, 255, .9);
	border-radius: 3px;
	box-shadow: 0 0 14px rgba(24, 140, 255, .55);
	cursor: pointer;
	transition: .2s;
}

.stage-head:hover {
	filter: brightness(1.15);
	box-shadow: 0 0 18px rgba(24, 140, 255, .75);
}

.stage-head.active {
	border-color: #f7ff57;
	box-shadow: 0 0 18px rgba(247, 255, 87, .7);
	filter: brightness(1.18);
}

.stage-tag {
	color: #fff;
	font-size: 17px;
	font-weight: 700;
	letter-spacing: 4px;
	text-shadow: 0 0 8px rgba(24, 140, 255, .65);
}

.stage-groups {
	display: flex;
	flex-direction: column;
	gap: 10px;
	flex: 1;
	min-height: 0;
}

.stage-group {
	position: relative;
	padding: 0 0 8px;
	border: 1px solid rgba(68, 193, 239, .28);
	border-radius: 4px;
	background: rgba(10, 63, 113, .32);
	overflow: hidden;
}

.group-name {
	width: 100%;
	box-sizing: border-box;
	margin-bottom: 8px;
	padding: 6px 10px;
	background: linear-gradient(90deg, rgba(24, 140, 255, .35), rgba(54, 198, 220, .2));
	border-bottom: 1px solid rgba(68, 193, 239, .35);
	color: #f7ff57;
	font-size: 13px;
	font-weight: 600;
	letter-spacing: 1px;
	text-align: center;
	cursor: pointer;
	transition: .2s;
}

.group-name:hover {
	background: linear-gradient(90deg, rgba(24, 140, 255, .55), rgba(54, 198, 220, .35));
	filter: brightness(1.1);
}

.group-name.active {
	background: linear-gradient(90deg, rgba(247, 255, 87, .35), rgba(247, 195, 76, .25));
	border-bottom-color: rgba(247, 255, 87, .65);
	box-shadow: inset 0 0 10px rgba(247, 255, 87, .25);
}

.group-items {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(64px, 1fr));
	gap: 5px;
	padding: 0 8px;
}

.topo-item {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 24px;
	padding: 2px 4px;
	border: 1px solid transparent;
	border-radius: 3px;
	color: #fff;
	font-size: 11px;
	text-align: center;
	cursor: pointer;
	transition: .2s;
}

.topo-item:hover {
	transform: translateY(-1px);
	filter: brightness(1.12);
	box-shadow: 0 0 12px rgba(68, 193, 239, .45);
}

/* 持续巩固 — 绿色 */
.topo-item.consolidating {
	background: linear-gradient(135deg, rgba(76, 217, 100, .85), rgba(56, 184, 80, .65));
	border-color: rgba(120, 230, 140, .8);
	box-shadow: 0 0 8px rgba(76, 217, 100, .35);
}

/* 发展不足 - 蓝色 */
.topo-item.insufficient {
	background: linear-gradient(135deg, rgba(24, 140, 255, .85), rgba(54, 198, 220, .65));
	border-color: rgba(120, 200, 255, .8);
	box-shadow: 0 0 8px rgba(24, 140, 255, .35);
}

/* 尚处空白 — 橙红色 */
.topo-item.blank {
	background: linear-gradient(135deg, rgba(255, 122, 69, .85), rgba(232, 93, 58, .65));
	border-color: rgba(255, 180, 140, .8);
	color: #fff;
	font-weight: 600;
	box-shadow: 0 0 8px rgba(255, 122, 69, .35);
}

.stage-arrow {
	position: absolute;
	right: -16px;
	top: 50%;
	transform: translateY(-50%);
	color: #44c1ef;
	font-size: 22px;
	font-weight: 700;
}

.topo-item.active {
	outline: 2px solid #f7ff57;
	outline-offset: 1px;
	filter: brightness(1.15);
	box-shadow: 0 0 14px rgba(247, 255, 87, .65);
}

/* 企业列表 */
.enterprise-body {
	display: flex;
	flex-direction: column;
}

.enterprise-tabs {
	display: flex;
	gap: 6px;
	margin-bottom: 12px;
}

.enterprise-tabs button {
	padding: 5px 12px;
	border: 1px solid rgba(68, 193, 239, .45);
	background: rgba(10, 63, 113, .25);
	color: #b8d2e8;
	font-size: 12px;
	cursor: pointer;
}

.enterprise-tabs button.active {
	background: linear-gradient(90deg, #168cff, #36c6dc);
	color: #fff;
	border-color: transparent;
}

/* 企业分页 */
.enterprise-pager {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	flex: 0 0 auto;
	padding-top: 10px;
	font-size: 12px;
	color: #b8d2e8;
}

.enterprise-pager button {
	padding: 4px 12px;
	border: 1px solid rgba(68, 193, 239, .45);
	background: rgba(10, 63, 113, .25);
	color: #b8d2e8;
	font-size: 12px;
	cursor: pointer;
}

.enterprise-pager button:hover:not(:disabled) {
	background: rgba(24, 140, 255, .35);
	color: #fff;
}

.enterprise-pager button:disabled {
	opacity: .4;
	cursor: not-allowed;
}

.enterprise-table {
	flex: 1;
	min-height: 0;
	overflow: auto;
	scrollbar-width: thin;
	scrollbar-color: #44c1ef rgba(10, 32, 78, .35);
}

.enterprise-table::-webkit-scrollbar {
	width: 8px;
	height: 8px;
}

.enterprise-table::-webkit-scrollbar-track {
	background: rgba(10, 32, 78, .35);
	border-radius: 4px;
	box-shadow: inset 0 0 4px rgba(0, 0, 0, .35);
}

.enterprise-table::-webkit-scrollbar-thumb {
	background: linear-gradient(180deg, #44c1ef, #168cff);
	border-radius: 4px;
	border: 1px solid rgba(120, 220, 255, .55);
	box-shadow: 0 0 6px rgba(24, 140, 255, .55);
}

.enterprise-table::-webkit-scrollbar-thumb:hover {
	background: linear-gradient(180deg, #5fd4ff, #1b99ff);
	box-shadow: 0 0 10px rgba(95, 212, 255, .75);
}

.et-head,
.et-row {
	display: grid;
	grid-template-columns: 2fr 1.2fr 1fr 0.8fr 1fr 0.8fr 1.4fr;
	gap: 6px;
	padding: 9px 8px;
	font-size: 12px;
}

.et-head {
	position: sticky;
	top: 0;
	background: rgba(24, 64, 134, .55);
	color: #8ad4ff;
	font-weight: 600;
	border-bottom: 1px solid rgba(68, 193, 239, .35);
}

.et-row {
	border-bottom: 1px dashed rgba(68, 193, 239, .18);
	color: #c8def0;
}

.et-row:hover {
	background: rgba(68, 193, 239, .08);
}

.et-name {
	color: #fff;
	font-weight: 600;
}

.et-type {
	color: #f7c34c;
}

.et-pos {
	color: #8ad4ff;
}

/* 底部4图表 */
.v2-charts {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 14px;
	min-height: 0;
}

.chart-box {
	min-width: 0;
}

.chart-body {
	position: relative;
	display: flex;
	flex-direction: column;
}

.chart {
	flex: 1;
	min-height: 200px;
}

.radar-summary {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 4px 0;
	border-top: 1px dashed rgba(68, 193, 239, .25);
}

.rs-score {
	display: flex;
	align-items: baseline;
	gap: 6px;
}

.rs-score strong {
	color: #f7ff57;
	font-size: 22px;
	font-weight: 700;
	text-shadow: 0 0 8px rgba(247, 255, 87, .45);
}

.rs-score span {
	color: #8ad4ff;
	font-size: 11px;
}

.rs-level {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 2px;
}

.rs-pill {
	padding: 2px 10px;
	background: rgba(247, 195, 76, .25);
	border: 1px solid rgba(247, 195, 76, .55);
	border-radius: 10px;
	color: #f7d68c;
	font-size: 11px;
}

.rs-level span:last-child {
	color: #8ad4ff;
	font-size: 11px;
}

@media (max-width: 1500px) {
	.v2-main {
		grid-template-columns: 1.3fr 1fr;
	}

	.et-head,
	.et-row {
		grid-template-columns: 2fr 1.2fr 1fr 0.8fr 1fr 0.8fr 1.4fr;
		font-size: 11px;
	}
}

@media (max-width: 1200px) {
	.industry-chain-v2-page {
		padding: 8px 18px 16px;
	}

	.v2-main {
		grid-template-columns: 1fr;
	}

	.v2-charts {
		grid-template-columns: repeat(2, 1fr);
	}
}

@media (max-width: 768px) {
	.industry-chain-v2-page {
		overflow: auto;
	}

	.v2-header {
		flex-wrap: wrap;
		gap: 12px;
		padding: 8px 12px;
	}

	.legend {
		margin-left: 0;
	}

	.v2-main {
		grid-template-columns: 1fr;
	}

	.v2-charts {
		grid-template-columns: 1fr;
	}

	.et-head,
	.et-row {
		grid-template-columns: 1.6fr 1fr 0.8fr 0.7fr 0.9fr 0.7fr 1.2fr;
		font-size: 10px;
	}
}
</style>
